import FormSymbolImages from "./AddSymbolPrintList";
import CONFIG from "config/config";
import CompanyLogoForm from "react-lib/apps/HISV3/common/CompanyLogoForm";
import { checkURLImage } from "../checkURLImage";

type HeaderPrintListProps = Partial<{
  createdDate: string;
  patientInfo: any;
  formName: string;
  styles: Record<string, any>;
  header: any;
  footer: any;
  images: any;
  pageMargins: number[];
}>;

const FORM_NAME = "AddHeaderCudentPrintList";
const DEFAULT_PAGE_MARGINS = [38, 200, 38, 20];

const LOGO_HEIGHT = 30;
const LOGO_RESIZE =
  1 -
  (CONFIG.LOGO_REPORT.find((i: any) => i.type === 1)?.height - LOGO_HEIGHT) /
    CONFIG.LOGO_REPORT.find((i: any) => i.type === 1)?.height;
const LOGO_WIDTH = CONFIG.LOGO_REPORT.find((i: any) => i.type === 1)?.width * LOGO_RESIZE;

export const AddHeaderCudentPrintListTH = async (doc: any, props: HeaderPrintListProps) => {
  let isValidProfileImage = false;
  if (props.patientInfo?.profile_image?.image) {
    isValidProfileImage = await checkURLImage(props.patientInfo?.profile_image?.image);
  }

  const haveEncounter = props.patientInfo?.encounterData != null;

  const companyLogoForm = await CompanyLogoForm({
    type: 1,
    font: `KanitLM`,
    height: LOGO_HEIGHT,
    form: FORM_NAME,
  });
  const { images } = companyLogoForm;

  return {
    ...doc,
    pageMargins: props.pageMargins ? props.pageMargins : DEFAULT_PAGE_MARGINS,
    header: () => {
      return {
        table: {
          widths: ["20%", "50%", "*"],
          body: [
            [
              {
                columns: [
                  {
                    image: "logo",
                    width: LOGO_WIDTH,
                    height: LOGO_HEIGHT,
                    margin: [5, 5, 0, 5],
                  },
                  {
                    text: `Dental Hospital of the Faculty of Dentistry, Chulalongkorn University`,
                    bold: true,
                    font: `KanitLM`,
                    fontSize: 12,
                    margin: [15, 10, 0, 0],
                  },
                ],
                colSpan: 3,
              },
              ...Array(2).fill({}),
            ],
            [
              {
                image: "profileImage",
                width: 75,
                height: 90,
                margin: [10, 0, 0, 5],
              },
              //* --- รูป Profile มีขอบ ---
              // {
              //   table: {
              //     body: [
              //       [
              //         {
              //           image: "profileImage",
              //           width: 75,
              //           height: 90,
              //         }
              //       ]
              //     ]
              //   },
              //   layout: {
              //     hLineWidth: () => 1,
              //     vLineWidth: () => 1,
              //     hLineColor: () => '#000000',
              //     vLineColor: () => '#000000',
              //     paddingLeft: () => 0,
              //     paddingRight: () => 0,
              //     paddingTop: () => 0,
              //     paddingBottom: () => 0,
              //   },
              //   margin: [10, 0, 0, 5],
              // },
              {
                colSpan: 2,
                table: {
                  widths: ["50%", "50%"],
                  body: [
                    [
                      {
                        text: [{ text: `HN: `, bold: true }, { text: props.patientInfo?.hn }],
                        font: `KanitLM`,
                        fontSize: 9,
                        colSpan: 2,
                      },
                      ...Array(1).fill({}),
                    ],
                    [
                      {
                        text: [
                          { text: `Name: `, bold: true },
                          { text: props.patientInfo?.full_name },
                        ],
                        font: `KanitLM`,
                        fontSize: 9,
                      },
                      {
                        text: [
                          { text: `Sex: `, bold: true },
                          {
                            text: props.patientInfo?.gender
                              ? props.patientInfo.gender === "F"
                                ? "หญิง"
                                : props.patientInfo.gender === "M"
                                ? "ชาย"
                                : props.patientInfo.gender
                              : "ไม่ระบุ",
                          },
                        ],
                        font: `KanitLM`,
                        fontSize: 9,
                      },
                    ],
                    [
                      {
                        text: [
                          { text: `Birthdate: `, bold: true },
                          { text: props.patientInfo?.birthdate },
                        ],
                        font: `KanitLM`,
                        fontSize: 9,
                      },
                      {
                        text: [
                          { text: `Age: `, bold: true },
                          { text: props.patientInfo?.full_age },
                        ],
                        font: `KanitLM`,
                        fontSize: 9,
                      },
                    ],
                    [
                      {
                        text: [
                          { text: `CitizenID/Passport: `, bold: true },
                          { text: props.patientInfo?.formatCitizenNo },
                        ],
                        font: `KanitLM`,
                        fontSize: 9,
                      },
                      {
                        text: [
                          { text: `Tel: `, bold: true },
                          { text: props.patientInfo?.present_address?.tel_mobile || "-" },
                        ],
                        font: `KanitLM`,
                        fontSize: 9,
                      },
                    ],
                    [
                      {
                        text: [
                          { text: `Visit date [VN/AN]: `, bold: true },
                          {
                            text: `${
                              haveEncounter
                                ? props.patientInfo?.encounterData?.formatVisitDate
                                : props.patientInfo?.formatVisitDate
                            } (${
                              haveEncounter
                                ? props.patientInfo?.encounterData?.number
                                : props.patientInfo?.patientEncounter
                            })`,
                          },
                        ],
                        font: `KanitLM`,
                        fontSize: 9,
                        colSpan: 2,
                      },
                      ...Array(1).fill({}),
                    ],
                    [
                      {
                        text: [
                          { text: `Division: `, bold: true },
                          {
                            text: haveEncounter
                              ? props.patientInfo?.encounterData?.division_name
                              : props.patientInfo?.division_name || "-",
                          },
                        ],
                        font: `KanitLM`,
                        fontSize: 9,
                        colSpan: 2,
                      },
                      ...Array(1).fill({}),
                    ],
                    [
                      {
                        text: [
                          { text: `Dentist(Instructor)/Student: `, bold: true },
                          {
                            text: `${
                              haveEncounter ? props.patientInfo?.encounterData?.doctor_name : ""
                            }${
                              haveEncounter
                                ? props.patientInfo?.encounterData?.student_name
                                  ? `/${props.patientInfo?.encounterData?.student_name}`
                                  : ""
                                : ""
                            }`,
                          },
                        ],
                        font: `KanitLM`,
                        fontSize: 9,
                        colSpan: 2,
                      },
                      ...Array(1).fill({}),
                    ],
                  ],
                },
                layout: {
                  paddingTop: (i: any, node: any) => {
                    return 0;
                  },
                  paddingBottom: (i: any, node: any) => {
                    return 0;
                  },
                  hLineWidth: (i: any, node: any) => {
                    return 0;
                  },
                  vLineWidth: (i: any, node: any) => {
                    return 0;
                  },
                },
              },
              ...Array(1).fill({}),
            ],
          ],
        },
        layout: {
          vLineWidth: (i: any, node: any) => {
            return 0;
          },
          hLineWidth: (i: any, node: any) => {
            return i === node.table.body.length ? 1 : 0;
          },
          hLineStyle: (i: any, node: any) => {
            return i === node.table.body.length ? { dash: { length: 2, space: 2 } } : null;
          },
        },
      };
    },
    footer: (currentPage: any, pageCount: any) => {
      if (props.footer) {
        return {
          table: {
            widths: ["*"],
            body: [
              [
                {
                  columns: [
                    {
                      text: `วันเวลาที่พิมพ์เอกสาร : ${props.createdDate} โดย ${
                        props.patientInfo?.printer || "-"
                      }`,
                      alignment: `left`,
                      font: `KanitLM`,
                      fontSize: 8,
                    },
                    {
                      text: props.footer,
                      alignment: `center`,
                      font: `THSarabunNew`,
                      fontSize: 12,
                    },
                    {
                      text: `${currentPage.toString()}/${pageCount}`,
                      alignment: `right`,
                      font: `KanitLM`,
                      fontSize: 8,
                    },
                  ],
                  border: [false, true, false, false],
                },
              ],
            ],
          },
          layout: {
            hLineStyle: function (i: any, node: any) {
              return { dash: { length: 2, space: 2 } };
            },
          },
        };
      } else {
        return {
          table: {
            widths: ["*"],
            body: [
              [
                {
                  columns: [
                    {
                      text: `วันเวลาที่พิมพ์เอกสาร : ${props.createdDate} โดย ${
                        props.patientInfo?.printer || "-"
                      }`,
                      alignment: `left`,
                      font: `KanitLM`,
                      fontSize: 8,
                    },
                    {
                      text: `${currentPage.toString()}/${pageCount}`,
                      alignment: `right`,
                      font: `KanitLM`,
                      fontSize: 8,
                    },
                  ],
                  border: [false, true, false, false],
                },
              ],
            ],
          },
          layout: {
            hLineStyle: function (i: any, node: any) {
              return { dash: { length: 2, space: 2 } };
            },
          },
        };
      }
    },
    images: {
      ...images,
      checked: FormSymbolImages.checked,
      unchecked: FormSymbolImages.unchecked,
      squarebox: FormSymbolImages.squarebox,
      checkmark: FormSymbolImages.checkmark,
      profileImage:
        isValidProfileImage && props.patientInfo?.profile_image?.image
          ? props.patientInfo?.profile_image?.image
          : `${origin}/static/images/user.png`,
      ...props.images,
    },
    styles: {
      ...(props.styles || {}),
    },
  };
};
